// ! GENERATED BY PLOP (blackfiskBulkServiceModule)
// ! Signature: 2026-03-26 (Git: fc33de9)

import type { Component } from "vue";

export const routes = [
  {
    path: "/vendorProduct/manage",
    name: "vendor-product-manager",
    component: (): Promise<Component> => import("./views/VendorProductManager.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
];
